import moment from 'moment';

import {
    SWITCH_LOADING_SCHEDULE,
    SWITCH_CREATE_POPUP,
    REQUEST_GET_SCHEDULE,
    RESPONSE_GET_SCHEDULE,
    RESPONSE_UPDATE_SCHEDULE,
    SET_CREATING_WRITE_SCHEDULE,
    UNSET_CREATING_WRITE_SCHEDULE,
    ADD_WRITE_SCHEDULE,
    REQUEST_FILTERS_PARAMS,
    RESPONSE_FILTERS_PARAMS,
    CHANGE_TIME_SCHEDULE,
    CHANGE_SCREEN_SCHEDULE,
    REQUEST_SETTINGS,
    RESPONSE_SETTINGS,
    TARIFF_END,
    REQUEST_CONFIRM_PHONE_CHECK,
    RESPONSE_CONFIRM_PHONE_CHECK,
    REQUEST_CONFIRM_PHONE_SEND,
    RESPONSE_CONFIRM_PHONE_SEND,
    RESET_DATA_SCHEDULE
} from './actions';

const initialState = {
    visibleCreatePopup: false,
    creatingData: null,
    loading: true,
    data: null,
    filials: null,
    services: null,
    workers: null,
    time: moment().format('Hmm'),
    settings: null,
    screens: {
        success: {
            active: false,
            data: null
        },
        tariffEnd: {
            active: false
        }
    },
    confirmPhone: {
        loading: false,
        sended: false,
        confirmed: false
    }
};

export default function reduser(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case TARIFF_END: {
            return {
                ...state,
                screens: {
                    ...state.screens,
                    tariffEnd: { active: true }
                }
            };
        }
        case SWITCH_LOADING_SCHEDULE:
            return { ...state, loading: !state.loading };
        case SWITCH_CREATE_POPUP:
            return { ...state, visibleCreatePopup: !state.visibleCreatePopup };
        case REQUEST_FILTERS_PARAMS:
        case REQUEST_SETTINGS:
            return { ...state, loading: true };
        case RESPONSE_FILTERS_PARAMS:
            return {
                ...state,
                filials: payload ? payload.filials : null,
                services: payload ? payload.services : null,
                workers: payload ? payload.workers : null,
                loading: false
            };
        case REQUEST_GET_SCHEDULE: {
            return {
                ...state,
                loading: true
            };
        }
        case RESPONSE_GET_SCHEDULE:
        case RESPONSE_UPDATE_SCHEDULE: {
            return {
                ...state,
                data: payload,
                loading: false
            };
        }
        case SET_CREATING_WRITE_SCHEDULE:
            return { ...state, creatingData: payload };
        case UNSET_CREATING_WRITE_SCHEDULE:
            return { ...state, creatingData: null };
        case CHANGE_SCREEN_SCHEDULE:
            return {
                ...state,
                screens: {
                    ...state.screens,
                    [payload.screen]: {
                        active: true,
                        data: payload.data
                    }
                }
            };
        case RESPONSE_SETTINGS:
            return {
                ...state,
                settings: payload
            };
        // ACTIONS
        case ADD_WRITE_SCHEDULE: {
            return {
                ...state,
                screens: {
                    ...state.screens,
                    success: {
                        ...state.screens.success,
                        data: payload
                    }
                }
            };
        }
        case CHANGE_TIME_SCHEDULE: {
            return { ...state, time: +payload.time.format('Hmm') };
        }
        case REQUEST_CONFIRM_PHONE_SEND:
        case REQUEST_CONFIRM_PHONE_CHECK: {
            return {
                ...state,
                confirmPhone: {
                    ...state.confirmPhone,
                    loading: true
                }
            };
        }
        case RESPONSE_CONFIRM_PHONE_SEND: {
            return {
                ...state,
                confirmPhone: {
                    ...state.confirmPhone,
                    loading: false,
                    sended: !payload
                }
            };
        }
        case RESPONSE_CONFIRM_PHONE_CHECK: {
            return {
                ...state,
                confirmPhone: {
                    ...state.confirmPhone,
                    loading: false,
                    confirmed: !payload
                }
            };
        }
        case RESET_DATA_SCHEDULE: {
            return {
                ...state,
                data: null
            };
        }
      default:
        return state;
    }
}
